import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { injectIntl } from 'react-intl'

import { AwardFiles } from 'containers/pages'
import { ACTIVITY_SECTIONS, AWARD_FILE_CATEGORY_TYPES } from 'constants/enums'
import { FileCard, Title } from 'components/misc'
import { DashboardGrid as Grid } from 'components/layout'
import { apiDownloadFile } from 'helpers/decorators/api'

const DownloadableFileCard = apiDownloadFile()(FileCard)

@injectIntl
class RPFiles extends Component {
  static propTypes = {
    residentialProject: PropTypes.object.isRequired,
    intl: PropTypes.func.isRequired
  }

  render() {
    const { residentialProject, intl } = this.props

    return (
      <div>
        <AwardFiles
          sectionId={ACTIVITY_SECTIONS.residential_project.id}
          category={AWARD_FILE_CATEGORY_TYPES.residentialProject.id}
          {...this.props}
        />
        {get(residentialProject, 'fileUrls.length', 0) > 0 &&
          <Grid.RightInner>
            <Title intlKey="moduleTitle.attached_with_observation" h2>
              Attached with observation
            </Title>
            <div className="row">
              {get(residentialProject, 'fileUrls', []).map((src, index) =>
                <div className="col-xs-12 col-md-6" key={src}>
                  <DownloadableFileCard
                    src={src}
                    file={{
                      title: `${intl.formatMessage({
                        id: 'label.attached_file',
                        defaultMessage: 'Attached file'
                      })} ${++index}`
                    }}
                  />
                </div>
              )}
            </div>
          </Grid.RightInner>}
      </div>
    )
  }
}

export default RPFiles
